import classNames from 'classnames';
import propTypes from 'prop-types';
import { Fragment, useContext } from 'react';
import ThemeContext from '../../providers/ThemeProvider';

const VoucherProgressBar = ({ steps, step }) => {
  const theme = useContext(ThemeContext);
  const numbers = new Array(steps).fill(null).map((entry, index) => index + 1);

  return (
    <>
      <div className="progress">
        {numbers.map((number) => {
          const active = number <= step;

          return (
            <Fragment key={number}>
              {number > 1 && (
                <span
                  className={classNames('bar', { 'bar--active': active })}
                />
              )}
              <span
                className={classNames('number', {
                  'number--active': active,
                  'number--selected': number === step,
                })}
              >
                {number}
              </span>
            </Fragment>
          );
        })}
      </div>
      <style jsx>{`
        .progress {
          display: flex;
          align-items: center;
          padding: 10px 20px 30px 20px;
        }
        .bar {
          background: #b3b3b3;
          height: 6px;
          flex-grow: 1;
        }
        .bar--active {
          background-color: ${theme.colors.buttonprimary};
        }
        .number {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 35px;
          width: 35px;
          background-color: #b3b3b3;
          border-radius: 50%;
          color: #fff;
          z-index: 1;
        }
        .number--active {
          background-color: ${theme.colors.buttonprimary};
        }
        .number--selected:before {
          position: absolute;
          top: 47px;
          content: '';
          width: 0;
          height: 0;
          border-left: 18px solid transparent;
          border-right: 18px solid transparent;
          border-bottom: 18px solid #c7c7c7;
          z-index: 1;
        }
        .number--selected:after {
          position: absolute;
          top: 48px;
          content: '';
          width: 0;
          height: 0;
          border-left: 18px solid transparent;
          border-right: 18px solid transparent;
          border-bottom: 18px solid #fff;
          z-index: 2;
        }
      `}</style>
    </>
  );
};

VoucherProgressBar.propTypes = {
  step: propTypes.number,
  steps: propTypes.number,
};

export default VoucherProgressBar;
